import React from "react";
import Alert from "components/Alert";
import { useTranslation } from "react-i18next";
import { buildingSettingsStore } from "../BuildingSettingsStore";
import { observer } from "mobx-react-lite";
import TextInput from "components/TextInput";

const Lifespan = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="text-lg font-semibold mb-2">
        {t("buildingSettings.lifespan")}
      </div>
      <div className="text-gray-700 text-sm font-normal mb-6">
        {t("buildingSettings.lifespanSubtitle")}
      </div>

      {Number(buildingSettingsStore.settings.life_span) > 50 && (
        <Alert
          type="attention"
          description={t("buildingSettings.lifespanAlert1")}
          className="mb-3 items-center"
        />
      )}

      {Number(buildingSettingsStore.settings.life_span) !== 50 && (
        <Alert
          type="attention"
          description={t("buildingSettings.lifespanAlert2")}
          className="mb-6 items-center"
        />
      )}

      <TextInput
        type="integer"
        placeholder={t("buildingSettings.pleaseSpecifyLifespan")}
        labelName={t("buildingSettings.serviceLifOfBuilding")}
        value={String(buildingSettingsStore.settings.life_span ?? "")}
        handleChange={(value) =>
          buildingSettingsStore.onChangeValue(value, "life_span")
        }
        min={0}
        unit={t("productEditor.years")}
      />
    </div>
  );
};

export default observer(Lifespan);
